export const API_URL = "https://meetingbackend.bns.co.kr";
